module.exports = __webpack_public_path__ + "static/img/8.8c6fa2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/zh/8.png
// module id = 6n/e
// module chunks = 0